import { render, staticRenderFns } from "./tax-dialog.vue?vue&type=template&id=7b495534&"
import script from "./tax-dialog.vue?vue&type=script&lang=js&"
export * from "./tax-dialog.vue?vue&type=script&lang=js&"
import style0 from "./tax-dialog.vue?vue&type=style&index=0&id=7b495534&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports